import { render, staticRenderFns } from "./ActionDischargeByNurse.vue?vue&type=template&id=3564dfad&"
import script from "./ActionDischargeByNurse.vue?vue&type=script&lang=ts&"
export * from "./ActionDischargeByNurse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3564dfad')) {
      api.createRecord('3564dfad', component.options)
    } else {
      api.reload('3564dfad', component.options)
    }
    module.hot.accept("./ActionDischargeByNurse.vue?vue&type=template&id=3564dfad&", function () {
      api.rerender('3564dfad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/v2/ActionDischargeByNurse.vue"
export default component.exports